import { Injectable } from '@angular/core';

import { CustomerTradeGroup } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomerTradeGroupService extends TmsWebBaseEditService<CustomerTradeGroup, CustomerTradeGroup> {
  constructor() {
    super('CustomerTradeGroup', $localize`Customer Trade Group`);
  }
}
